import { render, staticRenderFns } from "./TemplatesSettingSetup.vue?vue&type=template&id=641f1cac&"
import script from "./TemplatesSettingSetup.vue?vue&type=script&lang=js&"
export * from "./TemplatesSettingSetup.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesSettingSetup.vue?vue&type=style&index=0&id=641f1cac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports